import React, { useCallback, useEffect, useState } from "react";
import { GoogleMap } from "@react-google-maps/api";
import { IAddress } from "../../interfaces/address";

const ZOOM_ON_INITIAL_CENTER = 18;
const DEFAULT_ZOOM = 8.65;

// Center of the Pureto Rica
const defaultCenter = {
  lat: 18.2208,
  lng: -66.5901,
};

const GoogleMapLocationPicker: React.FC<
  IAddress.IGoogleMapLocationPickerProps
> = (props) => {
  const {
    styles,
    onMapLocationChanged,
    initialCenter,
    draggable = true,
  } = props;
  const [center, setCenter] = useState(initialCenter || defaultCenter);
  const [map, setMap] = useState(null) as any;

  useEffect(() => {
    setCenter(initialCenter || defaultCenter);
  }, [initialCenter]);

  useEffect(() => {
    if (map) {
      map.setOptions({ draggable: draggable });
    }
  }, [draggable, map]);

  const onGoogleMapLoad = useCallback(function callback(mapRef) {
    // With bound default zoom is not working
    // mapRef.fitBounds(getBounds());
    setMap(mapRef);
    // @ts-ignore
    mapRef.panTo(center);
  }, []);

  // Need to update the center
  const updateSelectedLocation = () => {
    if (map) {
      // @ts-ignore
      const coords = map.getCenter().toJSON();
      console.log(coords);
      onMapLocationChanged(coords);
    }
  };

  return (
    <div className="map">
      <div className="map-container">
        <GoogleMap
          id="producer-location-picker"
          mapContainerStyle={styles.container}
          zoom={initialCenter ? ZOOM_ON_INITIAL_CENTER : DEFAULT_ZOOM}
          center={center}
          onDragEnd={updateSelectedLocation}
          onLoad={onGoogleMapLoad}
        >
          <div
            style={{
              top: "50%",
              fontSize: 10,
              left: "50%",
              position: "absolute",
            }}
          >
            <img
              src="https://ik.imagekit.io/hnlpilvl5t/icons/icons8-marker-30_VKHxNJ9vU.png"
              alt="back"
            />
          </div>
        </GoogleMap>
      </div>
    </div>
  );
};

export default GoogleMapLocationPicker;
